import { render, staticRenderFns } from "./BalanceWithCard.vue?vue&type=template&id=319a6578&scoped=true"
import script from "./BalanceWithCard.vue?vue&type=script&lang=js"
export * from "./BalanceWithCard.vue?vue&type=script&lang=js"
import style0 from "./BalanceWithCard.vue?vue&type=style&index=0&id=319a6578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319a6578",
  null
  
)

export default component.exports